var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDockerIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3395 13.2496C30.6189 12.7497 28.9676 12.5622 27.6765 12.8122C27.5264 11.5622 26.8358 10.4685 25.6349 9.4998L24.9443 8.99982L24.4639 9.71854C23.8634 10.656 23.5632 11.9684 23.6533 13.2184C23.6833 13.6559 23.8334 14.4371 24.2838 15.1246C23.8634 15.3746 22.9927 15.687 21.8518 15.687H0.144346L0.0842979 15.937C-0.125871 17.187 -0.125871 21.0931 2.33611 24.093C4.19761 26.3741 6.95983 27.5303 10.5928 27.5303C18.4591 27.5303 24.2838 23.7492 27.016 16.9058C28.0969 16.937 30.4087 16.9058 31.5797 14.5621C31.6097 14.4996 31.6697 14.3746 31.8799 13.9059L32 13.6559L31.3395 13.2496ZM17.4983 4.4375H14.1957V7.56237H17.4983V4.4375ZM17.4983 8.18735H14.1957V11.3122H17.4983V8.18735ZM13.5952 8.18735H10.2925V11.3122H13.5952V8.18735ZM9.69203 8.18735H6.38938V11.3122H9.69203V8.18735ZM5.78889 11.9372H2.48623V15.0621H5.78889V11.9372ZM9.69203 11.9372H6.38938V15.0621H9.69203V11.9372ZM13.5952 11.9372H10.2925V15.0621H13.5952V11.9372ZM17.4983 11.9372H14.1957V15.0621H17.4983V11.9372ZM21.4015 11.9372H18.0988V15.0621H21.4015V11.9372Z",
    fill: "#2396ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockerIntegration);
export default __webpack_public_path__ + "static/media/docker-integration.13d1a9d049b20213a15b199f07fefce0.svg";
export { ForwardRef as ReactComponent };